import React, { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ProtectedRoute, PublicRoute } from '../components/ProtectedRoute';

const Login = lazy(() => import('../components/layout/Login'));
const Dashboard = lazy(() => import('../pages/Dashboard'));
const Users = lazy(() => import('../pages/Users'));
const Rooms = lazy(() => import('../pages/Rooms'));
const Webinars = lazy(() => import('../pages/Webinars'));
const Settings = lazy(() => import('../pages/Settings'));
const TestAuth = lazy(() => import('../pages/TestAuth'));
const WebinarForm = lazy(() => import('../pages/WebinarForm'));
const Elements = lazy(() => import('../pages/Elements'));
const ElementView = lazy(() => import('../pages/ElementView'));
const ElementFilesView = lazy(() => import('../pages/ElementFilesView'));
const CreateElementView = lazy(() => import('../pages/CreateElementView'));
const RoomForm = lazy(() => import('../pages/RoomForm'));
const PrompterElementCreate = lazy(() => import('../components/elements/PrompterElementCreate'));
const UserForm = lazy(() => import('../pages/UserForm'));
const UserDetail = lazy(() => import('../pages/UserDetail'));
const PhotoUpload = lazy(() => import('../pages/PhotoUpload'));
const UserPasswordChange = lazy(() => import('../pages/PasswordChange'));
const RoomDetail = lazy(() => import('../pages/RoomDetail'));
const EmailTemplates = lazy(() => import('../pages/EmailTemplates'));
const EmailTemplateForm = lazy(() => import('../pages/EmailTemplateForm'));

const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: '/test-auth',
    element: <TestAuth />,
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard/users" replace />,
      },
      {
        path: 'users',
        element: <Users />,
      },
      {
        path: 'user-form',
        element: <UserForm />,
      },
      {
        path: 'user-details',
        element: <UserDetail />
      },
      {
        path: 'user-photo-upload',
        element: <PhotoUpload />,
      },
      {
        path: 'user-change-password',
        element: <UserPasswordChange />,
      },
      {
        path: 'rooms',
        element: <Rooms />,
      },
      {
        path: 'room-form',
        element: <RoomForm />,
      },
      {
        path: 'room-details',
        element: <RoomDetail />,
      },
      {
        path: 'webinars',
        element: <Webinars />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
      {
        path: 'webinar-form',
        element: <WebinarForm />,
      },
      {
        path: 'elements',
        element: <Elements />,
      },
      {
        path: 'element/view',
        element: <ElementView />,
      },
      {
        path: 'element/fileview',
        element: <ElementFilesView />,
      },
      {
        path: 'element/create-element',
        element: <CreateElementView />,
      },
      {
        path: 'element/prompter/create',
        element: <PrompterElementCreate />,
      },
      {
        path: 'email-templates',
        element: <EmailTemplates />,
      },
      {
        path: 'email-template-form',
        element: <EmailTemplateForm />,
      },
    ],
  },
  {
    path: '/',
    element: <Navigate to="/dashboard/users" replace />,
  },
  {
    path: '*',
    element: <Navigate to="/dashboard/users" replace />,
  },
]);

export default router;
